/* eslint-disable */
import { LOCATION_CHANGE } from 'connected-react-router';
import { HOME_PAGE_PATH } from '../../../Pages/Home/Home.page.route';
import isIOS from '../../../Support/Is/IOS/IsIOS.support';
import isStandAlone from '../../../Support/Is/StandAlone/IsStandAlone.support';

/**
 * The middleware to specifically redirect, when re-entering the app,
 * to the last page before the user went out of the app. This problem
 * is only relevant on iOS with the Add To Home Screen apps.
 * @returns {Middleware} The logger middleware
 */
const redirectToLastVisitedPageForIOSMiddleware = () => (store) => (next) => (action) => {
  if (action.type !== LOCATION_CHANGE) {
    return next(action);
  }
  if (action.payload === null) {
    return next(action);
  }
  const isAddToHomeScreenAppIOS = isIOS() && isStandAlone();
  if (!isAddToHomeScreenAppIOS) {
    return next(action);
  }
  // WORKAROUND for iOS PWA remember last page:
  // If we can persist the router (from connected-router) using redux-persist
  // then we don't need to capture LOCATION_CHANGE action.type here.
  // For now just piggy back on the Filters Reducer to get the last navigation
  // link to solve the iOS Add To Home Screen issue where the app goes back to
  // the starting point instead of the last navigated page before leaving the app.
  const {
    filters: { redirect },
  } = store.getState();
  const isHome = action.payload.location.pathname === HOME_PAGE_PATH;
  const shouldRedirect = redirect !== null;
  if (isHome && shouldRedirect) {
    return next({
      ...action,
      payload: redirect,
    });
  }
  return next(action);
};

export default redirectToLastVisitedPageForIOSMiddleware;
